/**
 * Contextual RESA prompts + page-context resolution.
 * Suggested prompts adapt to the current route. Entity-scoped pages
 * (a contact / a transaction) also pass the record id so RESA can summarize or
 * propose actions for that specific record. Only real page context is used.
 */

const GENERIC = [
  "What needs my attention today?",
  "How am I doing this month?",
  "Which lead sources are producing closed business?",
];

const BY_PAGE = {
  dashboard: ["What needs my attention?", "Explain my Business Brief.", "How am I doing this month?"],
  crm: ["Who needs follow-up?", "Which hot leads are going cold?", "Summarize my active clients."],
  pipeline: ["Which leads need follow-up?", "What's stuck in my pipeline?", "What's closing soon?"],
  contact: ["Summarize this relationship.", "Draft a follow-up.", "When did I last connect?"],
  transaction: ["Summarize this transaction.", "What should I pay attention to?", "What's the commission status?"],
  goals: ["Explain my progress.", "How much more do I need to hit my income goal?", "Am I on pace?"],
  compliance: ["What professional deadlines are coming up?", "How is my CE tracking?", "When do my licenses renew?"],
  marketing: ["Give me three hooks for a listing.", "Draft a market-update post.", "Ideas for this week's content."],
  general: GENERIC,
};

/** Resolve { context_type, context_id, prompts, label } from a pathname. */
export function resolveResaContext(pathname) {
  const p = pathname || "/";
  const contactMatch = p.match(/^\/crm\/([^/]+)$/);
  const txMatch = p.match(/^\/transactions\/([^/]+)$/);

  if (p === "/") return ctx("dashboard");
  if (contactMatch) return ctx("contact", contactMatch[1]);
  if (p === "/crm") return ctx("crm");
  if (p === "/pipeline" || p === "/follow-ups") return ctx("pipeline");
  if (txMatch) return ctx("transaction", txMatch[1]);
  if (p === "/transactions" || p === "/commissions") return ctx("general");
  if (p === "/goals") return ctx("goals");
  if (["/compliance", "/education", "/memberships"].includes(p)) return ctx("compliance");
  if (p.startsWith("/marketing") || p === "/content-calendar") return ctx("marketing");
  return ctx("general");
}

function ctx(type, id = null) {
  return { context_type: type, context_id: id, prompts: BY_PAGE[type] || GENERIC, label: LABELS[type] };
}

const LABELS = {
  dashboard: "your dashboard", crm: "your CRM", pipeline: "your pipeline",
  contact: "this contact", transaction: "this transaction", goals: "your goals",
  compliance: "your compliance", marketing: "marketing", general: "your business",
};
